export default __webpack_public_path__ + "static/media/Skype.d724aa88.svg";